export default __webpack_public_path__ + "static/media/3-Cloudxier-Heavenlyblush-website-productpage.f65752a4.jpg";